import { atom } from "jotai";

export const notFoundSpotIdsAtom = atom<Set<string>>(new Set<string>());
